import { render, staticRenderFns } from "./EditExerciseConversationFree.vue?vue&type=template&id=3796fe57&"
import script from "./EditExerciseConversationFree.vue?vue&type=script&lang=ts&"
export * from "./EditExerciseConversationFree.vue?vue&type=script&lang=ts&"
import style0 from "./EditExerciseConversationFree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports